var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tw-w-14 tw-h-14"},[(_vm.item.lineItem.purchasable.type === 'cms-edition')?[_c('img',{staticClass:"tw-w-full",attrs:{"src":_vm.craftLogo}})]:(_vm.item.lineItem.purchasable.type === 'plugin-edition')?[(_vm.item.plugin.iconUrl)?_c('img',{staticClass:"tw-w-full",attrs:{"src":_vm.item.plugin.iconUrl}}):_vm._e()]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }